/*
 * Copyright © 2017-Present, The Freshwater Trust, all rights reserved.
 */

import {
    useCallback,
    useMemo,
} from "react";
import {PermitModal} from "./PermitModal";

export const ConservationActionPermitModal = (props) => {
    
    const {
        conservationActionPermit,
        editable = true,
        onUpdate,
        onHide = () => {},
        show = true,
        surveyTypeId = null,
    } = props;
    
    const onUpdatePermit = useCallback((permit) => {
        if (!conservationActionPermit || !permit) {
            return;
        }
        
        onUpdate({
            ...conservationActionPermit,
            Permit: permit,
            permitId: permit.permitId,
        })
        
    }, [conservationActionPermit, onUpdate]);
    
    const permit = conservationActionPermit?.Permit;
    
    return <PermitModal
        permit={permit}
        surveyTypeId={surveyTypeId}
        editable={editable}
        show={!!permit && show}
        onHide={onHide}
        onUpdate={onUpdatePermit}
    />;
}